package com.evoapps.evoshift.viewmodels

/**
 * Items added optimistically are shown under a placeholder id until the server answers with the
 * real one. Actions on them wait for that: an edit or delete would otherwise target a document
 * that does not exist (or create one under the placeholder).
 */
internal const val PENDING_ID_PREFIX = "pending-"

internal val String.isPending: Boolean get() = startsWith(PENDING_ID_PREFIX)
